import { ApprovalStepStatus } from '../../types';
import { useMemo } from 'react';
import { ApprovalEditPanelReviewTable } from './ApprovalEditPanelReviewTable';
import { ApprovalEditFullyApprovedAlert } from './ApprovalEditFullyApprovedAlert';
import { countChangeBetweenLists } from '../../utils/countChangesBetweenLists';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalEditPanelReview = props => {
  const {
    approvedApproverActorIds,
    approversAll,
    assetName,
    selectedApproverIdsMutable,
    superAdminUserIds
  } = props;
  const willBeApprovedAfterEdit = useMemo(() => countChangeBetweenLists(approvedApproverActorIds, selectedApproverIdsMutable) === 0, [approvedApproverActorIds, selectedApproverIdsMutable]);
  const approversWithStepStatuses = useMemo(() => {
    const approversWithStatus = approversAll.filter(approver => selectedApproverIdsMutable.includes(approver.actor.id)).map(approver => approvedApproverActorIds.includes(approver.actor.id) ? [approver, ApprovalStepStatus.APPROVED] : [approver, ApprovalStepStatus.APPROVAL_PENDING]);
    return approversWithStatus;
  }, [approversAll, approvedApproverActorIds, selectedApproverIdsMutable]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [willBeApprovedAfterEdit && /*#__PURE__*/_jsx(ApprovalEditFullyApprovedAlert, {}), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "300",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalEditPanel.stepTwoDescription",
        options: {
          assetName,
          count: approversWithStepStatuses.length
        }
      })
    }), /*#__PURE__*/_jsx(ApprovalEditPanelReviewTable, {
      approversWithStepStatuses: approversWithStepStatuses,
      superAdminUserIds: superAdminUserIds
    })]
  });
};